import { message } from 'antd';

const CONTACT_EMAIL = 'admin@hanwenchinese.com';

/**
 * Handle email contact click.
 * Tries to open the user's email client via mailto:,
 * and also copies the email address to clipboard as a fallback
 * (important for incognito/private browsing where mailto: is blocked).
 */
export function handleEmailContact(e: React.MouseEvent) {
  e.preventDefault();

  // Try to open email client — works in normal browsing mode
  // Use location.href instead of window.open to avoid a blank tab flash
  window.location.href = `mailto:${CONTACT_EMAIL}`;

  // Copy to clipboard as fallback — works even in incognito
  navigator.clipboard.writeText(CONTACT_EMAIL).then(
    () => {
      message.success(`Email copied to clipboard: ${CONTACT_EMAIL}`, 4);
    },
    () => {
      message.info(`Contact us at: ${CONTACT_EMAIL}`, 5);
    },
  );
}

export { CONTACT_EMAIL };
